import { InAppBrowserObject, InAppBrowserOptions } from '@ionic-native/in-app-browser'

export class InAppBrowserWeb {
	create(url: string, target?: string, _?: string | InAppBrowserOptions): InAppBrowserObject {
		window.open(url, target)
		return {} as InAppBrowserObject
	}
}
